"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A comunica mediator that goes over all actors in sequence and forwards I/O.
 * This required the action input and the actor output to be of the same type.
 */


var MediatorCombinePipeline =
/*#__PURE__*/
function (_core_1$Mediator) {
  _inherits(MediatorCombinePipeline, _core_1$Mediator);

  function MediatorCombinePipeline(args) {
    _classCallCheck(this, MediatorCombinePipeline);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediatorCombinePipeline).call(this, args));
  }

  _createClass(MediatorCombinePipeline, [{
    key: "mediate",
    value: function () {
      var _mediate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var testResults, handle, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, actor;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                testResults = this.publish(action);
                _context.next = 7;
                break;

              case 4:
                _context.prev = 4;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", action);

              case 7:
                _context.next = 9;
                return Promise.all(testResults.map(function (_ref) {
                  var reply = _ref.reply;
                  return reply;
                }));

              case 9:
                // Pass action to first actor,
                // and each actor output as input to the following actor.
                handle = action;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 13;
                _iterator = testResults.map(function (result) {
                  return result.actor;
                })[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 23;
                  break;
                }

                actor = _step.value;
                _context.next = 19;
                return actor.runObservable(handle);

              case 19:
                handle = _context.sent;

              case 20:
                _iteratorNormalCompletion = true;
                _context.next = 15;
                break;

              case 23:
                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t1 = _context["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 29:
                _context.prev = 29;
                _context.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 32:
                _context.prev = 32;

                if (!_didIteratorError) {
                  _context.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context.finish(32);

              case 36:
                return _context.finish(29);

              case 37:
                return _context.abrupt("return", handle);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 4], [13, 25, 29, 37], [30,, 32, 36]]);
      }));

      function mediate(_x) {
        return _mediate.apply(this, arguments);
      }

      return mediate;
    }()
  }, {
    key: "mediateWith",
    value: function mediateWith(action, testResults) {
      throw new Error("Method not supported.");
    }
  }]);

  return MediatorCombinePipeline;
}(core_1.Mediator);

exports.MediatorCombinePipeline = MediatorCombinePipeline;